import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="currentcolor" d="M2 3h25v1H2zM2 9.5h25v1H2zM2 16h25v1H2z" /></svg>;